import lodash from 'utils/Lodash';
import { create } from 'zustand';
import { immer } from 'zustand/middleware/immer';

const initialValue = {
  cartList: [], // 장바구니
  wishlist: [], // 위시리스트
  reviews: [], // 작성 리뷰
  couponList: [], // 쿠폰함
  orderList: [], // 주문내역
  cardList: [], // 카드
  inquiryList: [], // 문의내역
  shopOrderList: [], // 구매 상품 리스트
  deliveryAddress: [], // 배송지 리스트
};

const userDataStore = create(
  immer((set, get) => ({
    ...initialValue,
    actions: {
      /**
       * @param {string} key
       * @param {object} value
       */
      setData: (key, value) => set({ [key]: value }),
      /**
       * @param {string} key
       */
      getData: (key) => get()[key] || [],
      /**
       * @param {string} key
       * @param {object} value
       */
      addData: (key, value) => {
        const originData = get()[key] || [];

        set({ [key]: [...originData, value] });
      },
      /**
       * @param {string} key
       * @param {string} pk
       * @param {object} value
       */
      removeData: (key, pk, value) => {
        const originData = get()[key] || [];

        if (!originData.length) return;

        const fid = originData.findIndex((org) => org[pk] === value[pk]);
        const newData = [
          ...originData.slice(0, fid),
          ...originData.slice(fid + 1),
        ];

        set({ [key]: newData });
      },
      /**
       * @param {string} key
       * @param {object} originValue
       * @param {object} newValue
       */
      updateData: (key, originValue, newValue) => {
        const originData = get()[key] || [];

        if (!originData.length) return set({ [key]: [newValue] });

        const fid = originData.findIndex((org) =>
          lodash.isObjEqual(org, originValue)
        );

        if (fid === -1) return set({ [key]: [...originData, newValue] });

        const newData = [
          ...originData.slice(0, fid),
          newValue,
          ...originData.slice(fid + 1),
        ];

        set({ [key]: newData });
      },
      /**
       * @param {string} key
       * @param {number} index
       * @param {object} value
       * @returns
       */
      fetchData: (key, index, value) => {
        const originData = get()[key] || [];

        if (!originData.length || index === -1) return;

        const updatedData = originData.map((item, i) =>
          index === i ? { ...item, ...value } : item
        );

        set({ [key]: updatedData });
      },
      /**
       * @param {string} key
       * @returns
       */
      resetData: (key) => set({ [key]: initialValue[key] }),
      /**
       * @returns
       */
      resetAllData: () => set(() => ({ ...initialValue })),
    },
  }))
);

export const useUserDataAction = () => userDataStore((store) => store.actions);
export const useUserDataStack = () =>
  userDataStore((store) => {
    const { actions, ...remain } = store;

    return {
      ...remain,
    };
  });
